import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-20 bg-rugby-green-900 relative border-y border-rugby-green-800" data-id="element-211">
      <div className="container mx-auto px-4" data-id="element-212">
        <div className="max-w-3xl mx-auto" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-rugby-green-950 to-rugby-green-900 border border-rugby-gold-500/30 rounded-3xl p-6 md:p-16 text-center relative overflow-hidden shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-214">
            <div className="absolute inset-0 pattern-dots opacity-30" data-id="element-215" />

            <div className="relative z-10" data-id="element-216">
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 rounded-full bg-rugby-gold-500/10 border border-rugby-gold-500/30 mb-4 md:mb-8" data-id="element-217">
                <ShieldCheck className="text-rugby-gold-400 w-8 h-8 md:w-12 md:h-12" data-id="element-218" />
              </motion.div>

              <h2 className="text-4xl md:text-6xl font-display text-white mb-1 md:mb-2" data-id="element-219">
                7 DÍAS
              </h2>
              <h3 className="text-xl md:text-3xl font-display text-rugby-gold-400 mb-3 md:mb-6 tracking-wide" data-id="element-220">
                GARANTÍA TOTAL
              </h3>

              <p className="text-base md:text-xl text-white font-medium mb-2 md:mb-4" data-id="element-221">
                7 días para probarlo o te devolvemos el 100%
              </p>

              <p className="text-sm md:text-base text-slate-300 mb-4 md:mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-222">
                Abrís los tomos, probás los bonos en tu próximo entrenamiento o
                partido. Si no es lo que esperabas: sin preguntas, sin
                formularios, sin drama.
              </p>

              <span className="inline-block bg-rugby-green-950 text-slate-400 text-xs md:text-sm font-medium py-1.5 md:py-2 px-3 md:px-4 rounded-full border border-rugby-green-800" data-id="element-223">
                (Tasa de devoluciones &lt; 1%)
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}